import * as React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Markdown from "../Markdown";
import {Helmet} from "react-helmet";

function Learn(props) {
    const {posts, title} = props;
    React.useEffect(()=> {
        props.setCurrentRoute("learn");
    })
    return (
        <Grid
            item
            xs={12}
            md={8}
            sx={{
                '& .markdown': {
                    py: 3,
                },
            }}
        >
            <Helmet>
                <meta charSet="utf-8" />
                <title>Learning To Drive</title>
                <meta name="description" content="Our FAQ answers the common questions of new drivers, find all resources you might need to make the learning process as smooth as possible." />
            </Helmet>
            <Typography variant="h2" gutterBottom>
                {title}
            </Typography>
            <Divider/>
            {posts.map((text) => (
                <Markdown className="markdown" text={text} key={text.substring(0, 40)}/>
            ))}
        </Grid>
    );
}

Learn.propTypes = {
    posts: PropTypes.arrayOf(PropTypes.string).isRequired,
    title: PropTypes.string.isRequired,
};

export default Learn;
